import React from "react";
import { RadarElement } from "./radar.js";

export function Results({
  radarValues,
  changeToCompetenceGoalsForm,
  competenceGoalsState,
}) {
  return (
    <section>
      <div className="line"></div>

      <h2>Competency map</h2>
      {!competenceGoalsState ? (
        <>
          {" "}
          <p className="content-area">
            The resulting figure below illustrates competency. Look at the
            pattern. Which areas are the strongest? Which areas have the most
            potential for development?
          </p>
          <p className="content-area">
            You can now set yourself a competency goals and compare it with your
            current level of competence. Use the button below to start setting
            targets.
          </p>
          {!competenceGoalsState && (
            <button
              onClick={() => changeToCompetenceGoalsForm()}
              className="submit-button"
            >
              Set your competency goals
            </button>
          )}
        </>
      ) : (
        <>
          <p className="content-area">
            The colour red represents current competence and blue represents the
            set target level. Look at the resulting patterns and compare them.
            Use the resulting visualisation to consider which competency areas
            have the most potential for development. Use the observations to
            support the planning of your own competency development.
          </p>
        </>
      )}

      <RadarElement
        values={radarValues}
        competenceGoalsState={competenceGoalsState}
      />
    </section>
  );
}
